export default __webpack_public_path__ + "static/Birchbrook_Icon_Navy-07f48a37058f0465f4d93d611e67a920.svg";